module.exports = __webpack_public_path__ + "static/img/2.f6a5949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R404A/2.jpg
// module id = GeCn
// module chunks = 1